import { openDB } from "idb";

export const openDatabase = async () => {
  return openDB("AppDatabase", 2, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("pages")) {
        db.createObjectStore("pages", { keyPath: "index" });
      }
      if (!db.objectStoreNames.contains("fields")) {
        db.createObjectStore("fields", { keyPath: "index" });
      }
      if (!db.objectStoreNames.contains("tables")) {
        db.createObjectStore("tables", { keyPath: "index" });
      }
    },
  });
};

const saveDataToIndexedDB = async (storeName, data) => {
  const db = await openDatabase();
  const tx = db.transaction(storeName, "readwrite");
  const store = tx.objectStore(storeName);

  data.forEach((item, index) => {
    item.index = index;
  });
  if (data.length === 0) {
    await store.clear();  
    return
  }
  const promises = data.map((item) => store.put(item));
  await Promise.all(promises);
  await tx.done;
};

const getDataFromIndexedDB = async (storeName) => {
  const db = await openDatabase();
  const store = db.transaction(storeName).objectStore(storeName);
  return await store.getAll();
};

export const saveToIndexedDB = (key, data) => saveDataToIndexedDB(key, data);
export const getFromIndexedDB = (key) => getDataFromIndexedDB(key);
